import styles from './AchievementCard.module.css';
import lockIcon from '../../assets/icons/lock.svg';

export const AchievementCard = ({
  title,
  description,
  image,
  isLocked = false,
  statusText = '',
  coinAmount = null,
}) => {
  return (
    <div className={`${styles.card} ${isLocked ? styles.locked : ''}`}>
      <div className={styles.imageContainer}>
        <img src={image} alt={title} className={styles.achievementImage} />
        {isLocked && (
          <div className={styles.lockOverlay}>
            <img src={lockIcon} alt="Заблокировано" className={styles.lockIcon} />
          </div>
        )}
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.description}>{description}</p>
        {coinAmount !== null ? <p className={styles.coin}>+{coinAmount} ЮФУнтов</p> : null}
        {statusText ? <p className={styles.status}>{statusText}</p> : null}
      </div>
    </div>
  );
};
